import { breakpoints, Container } from "@brightagency/headstart-common";
import * as React from "react";
import { Helmet } from "react-helmet";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import { useCurrentRouteData, useGlobalData } from "../../services/app-state";
import { convertToRelativeUrl } from "../../utils";
import { HeroPage } from "../organisms/HeroPage";

const PageWrapper = styled.div`
    background-color: white;
`;

const Inner = styled.div`
    text-align: center;
    padding: 75px 0;
    ${breakpoints.large} {
        padding: 100px 0;
    }
`;

const NotFound = () => {
    const [
        {
            site: { siteURL },
        },
    ] = useGlobalData();

    return (
        <>
            <Helmet>
                <title>Page Not Found</title>
            </Helmet>
            <HeroPage title="Page Not Found" />
            <PageWrapper>
                <Container>
                    <Inner>
                        <h2>The requested page could not be found.</h2>
                        <p>
                            Please ensure you do not have any typos in the URL. Alternatively,{" "}
                            <Link to={convertToRelativeUrl(siteURL)}>click here</Link> to head to
                            the homepage.
                        </p>
                    </Inner>
                </Container>
            </PageWrapper>
        </>
    );
};

export const NotFoundBoundary: React.FC<{
    children: React.ReactNode;
}> = props => {
    const location = useLocation();
    const page = useCurrentRouteData(location.pathname);
    if (!page) {
        return <NotFound />;
    }
    return <>{props.children}</>;
};
